/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
// @ts-ignore
import { GetProductCategoryStatuses200Response } from '../models';
// @ts-ignore
import { PostProductCategoryStatusRequest } from '../models';
// @ts-ignore
import { ProductCategoryStatus } from '../models';
/**
 * ProductCategoryStatusApi - axios parameter creator
 * @export
 */
export const ProductCategoryStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商材カテゴリステータス一覧取得API
         * @summary 商材カテゴリステータス一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategoryStatuses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/product_category_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材カテゴリステータス作成API
         * @summary 商材カテゴリステータス作成API
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProductCategoryStatus: async (postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/product_category_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProductCategoryStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材カテゴリステータス更新API
         * @summary 商材カテゴリステータス更新API
         * @param {number} productCategoryStatusId 商材カテゴリステータスID
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProductCategoryStatus: async (productCategoryStatusId: number, postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCategoryStatusId' is not null or undefined
            assertParamExists('putProductCategoryStatus', 'productCategoryStatusId', productCategoryStatusId)
            const localVarPath = `/api/user/product_category_statuses/{productCategoryStatusId}`
                .replace(`{${"productCategoryStatusId"}}`, encodeURIComponent(String(productCategoryStatusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProductCategoryStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCategoryStatusApi - functional programming interface
 * @export
 */
export const ProductCategoryStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductCategoryStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 商材カテゴリステータス一覧取得API
         * @summary 商材カテゴリステータス一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategoryStatuses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductCategoryStatuses200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCategoryStatuses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材カテゴリステータス作成API
         * @summary 商材カテゴリステータス作成API
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postProductCategoryStatus(postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCategoryStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postProductCategoryStatus(postProductCategoryStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材カテゴリステータス更新API
         * @summary 商材カテゴリステータス更新API
         * @param {number} productCategoryStatusId 商材カテゴリステータスID
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProductCategoryStatus(productCategoryStatusId: number, postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProductCategoryStatus(productCategoryStatusId, postProductCategoryStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductCategoryStatusApi - factory interface
 * @export
 */
export const ProductCategoryStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductCategoryStatusApiFp(configuration)
    return {
        /**
         * 商材カテゴリステータス一覧取得API
         * @summary 商材カテゴリステータス一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategoryStatuses(options?: any): AxiosPromise<GetProductCategoryStatuses200Response> {
            return localVarFp.getProductCategoryStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 商材カテゴリステータス作成API
         * @summary 商材カテゴリステータス作成API
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProductCategoryStatus(postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: any): AxiosPromise<ProductCategoryStatus> {
            return localVarFp.postProductCategoryStatus(postProductCategoryStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 商材カテゴリステータス更新API
         * @summary 商材カテゴリステータス更新API
         * @param {number} productCategoryStatusId 商材カテゴリステータスID
         * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProductCategoryStatus(productCategoryStatusId: number, postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putProductCategoryStatus(productCategoryStatusId, postProductCategoryStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductCategoryStatusApi - interface
 * @export
 * @interface ProductCategoryStatusApi
 */
export interface ProductCategoryStatusApiInterface {
    /**
     * 商材カテゴリステータス一覧取得API
     * @summary 商材カテゴリステータス一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApiInterface
     */
    getProductCategoryStatuses(options?: AxiosRequestConfig): AxiosPromise<GetProductCategoryStatuses200Response>;

    /**
     * 商材カテゴリステータス作成API
     * @summary 商材カテゴリステータス作成API
     * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApiInterface
     */
    postProductCategoryStatus(postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: AxiosRequestConfig): AxiosPromise<ProductCategoryStatus>;

    /**
     * 商材カテゴリステータス更新API
     * @summary 商材カテゴリステータス更新API
     * @param {number} productCategoryStatusId 商材カテゴリステータスID
     * @param {PostProductCategoryStatusRequest} [postProductCategoryStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApiInterface
     */
    putProductCategoryStatus(productCategoryStatusId: number, postProductCategoryStatusRequest?: PostProductCategoryStatusRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postProductCategoryStatus operation in ProductCategoryStatusApi.
 * @export
 * @interface ProductCategoryStatusApiPostProductCategoryStatusRequest
 */
export interface ProductCategoryStatusApiPostProductCategoryStatusRequest {
    /**
     * 
     * @type {PostProductCategoryStatusRequest}
     * @memberof ProductCategoryStatusApiPostProductCategoryStatus
     */
    readonly postProductCategoryStatusRequest?: PostProductCategoryStatusRequest
}

/**
 * Request parameters for putProductCategoryStatus operation in ProductCategoryStatusApi.
 * @export
 * @interface ProductCategoryStatusApiPutProductCategoryStatusRequest
 */
export interface ProductCategoryStatusApiPutProductCategoryStatusRequest {
    /**
     * 商材カテゴリステータスID
     * @type {number}
     * @memberof ProductCategoryStatusApiPutProductCategoryStatus
     */
    readonly productCategoryStatusId: number

    /**
     * 
     * @type {PostProductCategoryStatusRequest}
     * @memberof ProductCategoryStatusApiPutProductCategoryStatus
     */
    readonly postProductCategoryStatusRequest?: PostProductCategoryStatusRequest
}

/**
 * ProductCategoryStatusApi - object-oriented interface
 * @export
 * @class ProductCategoryStatusApi
 * @extends {BaseAPI}
 */
export class ProductCategoryStatusApi extends BaseAPI implements ProductCategoryStatusApiInterface {
    /**
     * 商材カテゴリステータス一覧取得API
     * @summary 商材カテゴリステータス一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApi
     */
    public getProductCategoryStatuses(options?: AxiosRequestConfig) {
        return ProductCategoryStatusApiFp(this.configuration).getProductCategoryStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材カテゴリステータス作成API
     * @summary 商材カテゴリステータス作成API
     * @param {ProductCategoryStatusApiPostProductCategoryStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApi
     */
    public postProductCategoryStatus(requestParameters: ProductCategoryStatusApiPostProductCategoryStatusRequest = {}, options?: AxiosRequestConfig) {
        return ProductCategoryStatusApiFp(this.configuration).postProductCategoryStatus(requestParameters.postProductCategoryStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材カテゴリステータス更新API
     * @summary 商材カテゴリステータス更新API
     * @param {ProductCategoryStatusApiPutProductCategoryStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryStatusApi
     */
    public putProductCategoryStatus(requestParameters: ProductCategoryStatusApiPutProductCategoryStatusRequest, options?: AxiosRequestConfig) {
        return ProductCategoryStatusApiFp(this.configuration).putProductCategoryStatus(requestParameters.productCategoryStatusId, requestParameters.postProductCategoryStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
